import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/airlines', request)
}

export {get}
